import { NavigationModel } from '../../shared/models/navigation.model';
import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SubscriptionList } from '../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../shared/services/util.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SideNavComponent implements OnInit, OnDestroy {
  @Input('navItems') public navItems: NavigationModel[];
  isNavHidden: boolean = false;
  private subs: SubscriptionList = {};
  navigationMenu: NavigationModel[];
  isDeliveryChecklist = false;
  searchForm: UntypedFormGroup;

  constructor(private readonly router: Router,
    private readonly formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.isNavHidden = localStorage.getItem('asp-toggle-nav') === 'true';
    this.navigationMenu = this.navItems.filter(t => this.router.url.startsWith(t.route));
    this.isDeliveryChecklist = this.isDeliveryChecklistRoute();
    this.subs.router = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.navigationMenu = this.navItems.filter(t => event.url.startsWith(t.route));
        this.isDeliveryChecklist = this.isDeliveryChecklistRoute();
        this.cleanFilters(event.url);
      }
    });
    this.initializeSearchForm();
  }

  initializeSearchForm() {
    this.searchForm = this.formBuilder.group({
      searchField: [null],
      searchInput: [null]
    });
  }

  cleanFilters(url: string) {
    if (url !== '/' && !url.includes("deliveryChecklist/summary/search")) {
      this.searchForm.reset();
    }
  }

  isDeliveryChecklistRoute() {
    return this.router.url.includes("deliveryChecklist");
  }

  allowedSideNavWithCount(childNavitem) {
    const allowedName = ['navigation.unavailableVehicles', 'navigation.pendingAppointments', 'navigation.pending', 'navigation.completed'];
    return childNavitem?.count > 0 && allowedName.includes(childNavitem.name);
  }

  toggleNav(val: boolean) {
    this.isNavHidden = val;
    localStorage.setItem('asp-toggle-nav', String(val));
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }


  fetchSearchRecords() {
    const searchField = this.searchForm.value.searchField;
    let searchInput = this.searchForm.value.searchInput?.trim();
    if (searchField && searchInput) {
      searchInput = this.cleanSearchInput(searchInput);
      const searchFilter = { [searchField]: searchInput };
      this.router.navigateByUrl('/asp/deliveryChecklist/summary', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/asp/deliveryChecklist/summary/search'], { state: { filters: searchFilter } });
      });
    }
  }

  cleanSearchInput(searchString: string) {
    let searchInput = searchString;
    if (searchInput.startsWith('+')) {
      searchInput = searchInput.slice(1);
    }
    return searchInput;
  }
}
